module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-6-en-US-067d2a3a3290d80b285c877ec42fc201.png";